import { convertToNumber } from 'utils/converters';

import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';

import useGetRowData from '../../hooks/useGetRowData';
import { EditDutyCalculationValueSleepDutySkeleton } from 'components/admin-portal/Tables/CLA/DutyCalculationValueSleepDuty/components/form/components/EditDutyCalculationValueSleepDutySkeleton';
import CreateEditDutyCalculationValueSleepDutyForm from 'components/admin-portal/Tables/CLA/DutyCalculationValueSleepDuty/components/form/CreateEditDutyCalculationValueSleepDutyForm';

export default function CreateEditDutyCalculationValueSleepDuty({
  handleClose,
  rowId
}: FormComponentProps) {
  const { isFetching, convertedData } = useGetRowData(convertToNumber(rowId));

  return isFetching ? (
    <EditDutyCalculationValueSleepDutySkeleton />
  ) : (
    <CreateEditDutyCalculationValueSleepDutyForm
      handleClose={handleClose}
      rowData={convertedData}
    />
  );
}
